import axios        from 'axios';
import authHeader   from 'services/auth-header';

const UNLOCK_TOKEN_KEY   = 'wallet:unlock_token';
const UNLOCK_EXPIRES_KEY = 'wallet:unlock_expires_at';
const API_URL            = process.env.REACT_APP_API_ENDPOINT + 'payment/wallet_passcode/';

class WalletPasscodeService  {
  status() {
    return axios
      .get(API_URL + 'status', { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

  setup(parameters) {
    return axios
      .post(API_URL + 'setup', parameters, { headers: authHeader() })
      .then(response => {
        this.storeUnlock(response.data);
        return response.data;
      }
    );
  }

  verify(parameters) {
    return axios
      .post(API_URL + 'verify', parameters, { headers: authHeader() })
      .then(response => {
        this.storeUnlock(response.data);
        return response.data;
      }
    );
  }

  storeUnlock(data) {
    if (!data || !data.unlock_token) return;

    sessionStorage.setItem(UNLOCK_TOKEN_KEY, data.unlock_token);
    sessionStorage.setItem(UNLOCK_EXPIRES_KEY, String(Date.now() + (data.expires_in || 0) * 1000));
  }

  clearUnlock() {
    sessionStorage.removeItem(UNLOCK_TOKEN_KEY);
    sessionStorage.removeItem(UNLOCK_EXPIRES_KEY);
  }

  unlockToken() {
    const expiresAt = Number(sessionStorage.getItem(UNLOCK_EXPIRES_KEY));

    if (!expiresAt || expiresAt <= Date.now()) {
      this.clearUnlock();
      return null;
    }

    return sessionStorage.getItem(UNLOCK_TOKEN_KEY);
  }

  expiresAt() {
    return Number(sessionStorage.getItem(UNLOCK_EXPIRES_KEY)) || 0;
  }

  isUnlocked() {
    return !!this.unlockToken();
  }

  gateCode(error) {
    const response = error && error.response;

    if (!response || response.status !== 403) return null;

    const code = (response.data && response.data.code) || '';

    return String(code).indexOf('wallet_passcode') === 0 ? code : null;
  }
}

export default new WalletPasscodeService();
